var map = {
	"./wallpaper_1.jpeg": 4783,
	"./wallpaper_10.jpeg": 7153,
	"./wallpaper_11.jpeg": 3105,
	"./wallpaper_12.jpeg": 6088,
	"./wallpaper_13.jpeg": 2014,
	"./wallpaper_14.jpeg": 5244,
	"./wallpaper_15.jpeg": 7520,
	"./wallpaper_16.jpeg": 6326,
	"./wallpaper_17.jpeg": 964,
	"./wallpaper_18.jpeg": 4361,
	"./wallpaper_19.jpeg": 1257,
	"./wallpaper_2.jpeg": 6155,
	"./wallpaper_20.jpeg": 8171,
	"./wallpaper_21.jpeg": 5626,
	"./wallpaper_22.jpeg": 4027,
	"./wallpaper_23.jpeg": 8911,
	"./wallpaper_24.jpeg": 6415,
	"./wallpaper_25.jpeg": 5503,
	"./wallpaper_26.jpeg": 2770,
	"./wallpaper_3.jpeg": 6853,
	"./wallpaper_4.jpeg": 7397,
	"./wallpaper_5.jpeg": 1985,
	"./wallpaper_6.jpeg": 6561,
	"./wallpaper_7.jpeg": 9602,
	"./wallpaper_8.jpeg": 1858,
	"./wallpaper_9.jpeg": 2257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1107;